import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { Header } from 'components/header';

export const HeaderTitle: React.FC<IBaseProps> = ({ children }) => <Header>{children}</Header>;
